import { v4 as uuidv4 } from 'uuid'

import N3Icon from 'assets/images/spons/3n.jpg'
import AwsIcon from 'assets/images/spons/aws.svg'
import AuaIcon from 'assets/images/spons/aua.png'
import GridIcon from 'assets/images/spons/grid.png'
import AdobeIcon from 'assets/images/spons/adobe.png'
import How2bIcon from 'assets/images/spons/how2b.png'
import ArtakIcon from 'assets/images/spons/artak.jpg'
import HrdroneIcon from 'assets/images/spons/hrdrone.png'
import IxprintIcon from 'assets/images/spons/ixprint.png'
import DasMetaIcon from 'assets/images/spons/dasmeta.png'
import JetBrainsIcon from 'assets/images/spons/jetBrains.png'
import MinistryIcon from 'assets/images/spons/ministry.png'

import { SponsorCardInfo } from 'components/containers/Sponsors/SponsorCard'

const sponsorsData2025: SponsorCardInfo[] = [
  {
    id: uuidv4(),
    categoryName: 'PLATINUM',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.jetbrains.com/',
        image: JetBrainsIcon,
        name: 'jetbrains',
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://www.dasmeta.com/',
        image: DasMetaIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://www.griddynamics.com/',
        image: GridIcon,
        name: 'griddynamics',
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'GOLD',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://www.adobe.com/',
        image: AdobeIcon,
        name: 'adobe',
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'SPECIAL',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://cse.aua.am/',
        image: AuaIcon,
        name: 'aua',
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://aws.amazon.com/',
        image: AwsIcon,
        vacantions: undefined,
      },
    ],
  },
  {
    id: uuidv4(),
    categoryName: 'PARTNERS',
    sponsors: [
      {
        id: uuidv4(),
        url: 'https://hightech.gov.am/hy/tegekatvakan-kentron/ayl/norutyunner/aws-community-day-armenia-2025',
        image: MinistryIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://hrdrone.am/events/S6tPGy-aws-community-day',
        image: HrdroneIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://how2b.am/',
        image: How2bIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://lxprint.am/',
        image: IxprintIcon,
        vacantions: undefined,
      },
      {
        id: uuidv4(),
        url: 'https://t.me/threenstartups/979',
        image: N3Icon,
        vacantions: undefined,
        style: {
          height: 142,
        },
      },
      {
        id: uuidv4(),
        url: 'https://t.me/Armtechblog/1717',
        image: ArtakIcon,
        vacantions: undefined,
        style: {
          height: 142,
        },
      },
    ],
  },
]

export default sponsorsData2025
